import { Bubble } from 'js/bubbleCore/bubbles/types';
import { IGameData, Place } from 'js/bubbleCore/types';
import { removeFromSpace } from 'js/bubbleCore/utils/removeFromSpace';
import { addToSpace } from 'js/bubbleCore/utils/addToSpace';
import { setGridValue } from 'js/bubbleCore/utils/setGridValue';

export function addToPlace(bubble: Bubble, data: IGameData, place: Place): void {
  if (place === Place.Grid) {
    setGridValue(data.grid, bubble.col, bubble.row, bubble);
  } else if (place === Place.Shooter) {
    data.shooter.bubblesQueue.push(bubble);
  } else if (place === Place.ShootingSpace) {
    addToSpace(data.shootingSpace, bubble);
  } else if (place === Place.PopOutSpace) {
    addToSpace(data.popOutSpace, bubble);
  }
}